import { gql } from '@apollo/client';

export const GET_CHAT_TOKEN = gql`
  query GetChatToken {
    getChatToken
  }
`;

export const VALIDATE_CHAT_MESSAGE = gql`
  query ValidateChatMessage($text: String!, $channelCid: String) {
    validateChatMessage(text: $text, channelCid: $channelCid) {
      violationVariant
      violationMessage
      violations {
        variant
        text
      }
    }
  }
`;
